import React, { useState, useEffect } from 'react'
import { Grid, Typography } from '@material-ui/core'
import GenotypeFilter from 'src/views/VariantsView/Toolbar/FiltersPanelMenu/GenotypeFilter'

function GenotypeFilterModal({ value = [], onChange, onClose }) {
  const [localValue, setLocalValue] = useState(value)

  // Update local state when prop changes
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  // Update parent state whenever localValue changes
  useEffect(() => {
    console.log('Genotype filter value changed:', localValue)
    onChange(localValue)
  }, [localValue, onChange])

  console.log('GenotypeFilterModal received value:', value, 'localValue:', localValue)

  const handleChange = (newValue) => {
    console.log('Genotype filter changed locally:', newValue)
    setLocalValue(newValue)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Genotype Filter
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Select genotype categories and specific genotype values to filter variants.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <GenotypeFilter gtFilterEvent={localValue} setGtFilterEvent={handleChange} />
      </Grid>
    </Grid>
  )
}

export default GenotypeFilterModal
